export default "__VITE_ASSET__COES8ak___"